const RECAPTCHA_V2 = window.config.RECAPTCHA_V2;
const pdpLinkClickMapper = require("../../components/cards/detail/product/atm-mapper-pdp-link-click");
const formatDateString = require("../../../common/utility/date-stringformatter");
module.exports = function RescheduleDelivery(
  rescheduleDeliveryService,
  missedDeliveryService,
  googleCaptchaService,
  settingsService,
  $stateParams,
  $location,
  $rootScope,
  atm
) {
  return {
    restrict: "E",
    scope: true,

    template: require("./rescheduledelivery-template.html"),
    link(scope) {
      $rootScope.orderNumber = $stateParams.ordernumber;
      scope.loading = false;
      scope.showReCaptcha = false;
      scope.showReCaptchaErrorMessage = false;
      scope.recaptchaV2Key = RECAPTCHA_V2;
      scope.emailVisible = true;
      scope.phoneVisible = true;
      scope.pickupVisible = true;
      scope.lblPickupVisible = true;
      scope.cancelorderVisible = true;
      scope.lblCancelorderVisible = true;
      scope.rescheduledelivryVisible = true;
      scope.lblRescheduledelivryVisible = true;
      scope.showRescheduleContainer = false;
      scope.showDeliveredOrOnItsWay = false;
      scope.showInvalidResponsePage = false;
      scope.showCancelPage = false;
      scope.showCancelConfirmationPage = false;

      scope.manageOrderDescription = `Need to make a change to your order? No worries! Choose one
      of the options below, and we'll sort it out for you.`;

      scope.cancelOrderDescription = `We've got your request to cancel the order, and
      we're already on it! Keep an eye on your inbox for an email with more
      info about your refund. <br> Didn't cancel it? Contact us, and we'll help you out.`;

      scope.deliveredOrderDescription = `It looks like your order has already been delivered,
      so it's too late to make any changes.<br> Need help? Contact us, and we'll help you out.`;

      scope.onitswayOrderDescription = `The driver is already on the road, so it's too late to make
      any changes to your order. Check your BWS profile on the BWS App or website for updates on
      your delivery.<br> Need help? Contact us, and we'll help you out.`;

      scope.invalidOrderDescription = `Sorry, we don't recognize these order details. Try
      returning to this page using the link in the last SMS we sent you.`;

      scope.cancelConfirmationDescription = `Keep an eye on your email inbox. We'll be in
      touch when your order has been successfully cancelled.`;

      settingsService
        .getSettingValue("GoogleReCaptcha", "EnableGoogleReCaptchaNew")
        .then(function (response) {
          scope.showReCaptcha = response;
          if (scope.showReCaptcha) {
            googleCaptchaService.loadReCaptcha();
          }
        });

      var myscope = scope;

      function updateVisibility(
        pickup,
        lblPickup,
        reschedule,
        lblReschedule,
        cancelOrder,
        lblCancelOrder
      ) {
        scope.pickupVisible = pickup;
        scope.lblPickupVisible = lblPickup;
        scope.rescheduledelivryVisible = reschedule;
        scope.lblRescheduledelivryVisible = lblReschedule;
        scope.cancelorderVisible = cancelOrder;
        scope.lblCancelorderVisible = lblCancelOrder;
      }

      function showHideElements(
        pickup,
        lblPickup,
        reschedule,
        lblReschedule,
        cancelOrder,
        lblCancelOrder
      ) {
        myscope.ShowPickup = pickup;
        myscope.ShowReschdule = reschedule;
        myscope.ShowCancelOrder = cancelOrder;

        updateVisibility(
          pickup,
          lblPickup,
          reschedule,
          lblReschedule,
          cancelOrder,
          lblCancelOrder
        );

        scope.selected.isActive;
      }

      myscope.ShowHidePickupStore = function () {
        showHideElements(true, true, false, false, false, false);
      };

      myscope.ShowHideReschedule = function () {
        showHideElements(false, false, true, true, false, false);
      };

      myscope.ShowHideCancelOrder = function () {
        showHideElements(false, false, false, false, true, true);
      };

      scope.ShowHideEmail = function () {
        scope.emailVisible = !scope.emailVisible;
        scope.phoneVisible = false;
        scope.emailVisible = true;
      };

      scope.ShowHidePhone = function () {
        scope.phoneVisible = !scope.phoneVisible;
        scope.emailVisible = false;
        scope.phoneVisible = true;
      };

      scope.GetOrdersReschedule = function () {
        rescheduleDeliveryService
          .OrdersReschedule($rootScope.orderNumber)
          .then((response) => {
            if (response == undefined || response.ErrorMessage != null) {
              scope.showInvalidResponsePage = true;
              scope.showDeliveredOrOnItsWay,
                scope.showRescheduleContainer,
                (scope.showCancelPage = false);
            } else {
              $rootScope.OrderNo = response.OrderId;
              $rootScope.rescheduleResponse = response;
              scope.reschDetails = response;
              scope.isShow = scope.reschDetails.IsGuest;

              if (response.CarrierName.toLowerCase() === "jimmybrings") {
                if(response.CarrierStatus.toLowerCase() === "cancelled" ||
                response.DeliveryStatus.toLowerCase() === "cancelled") {
                  scope.showCancelPage = true;
                } else if (response.CanModify === false) {
                  scope.showDeliveredOrOnItsWay = true;
                } else {
                  $location.url("/dnrcd");
                }
              } else if (
                response.CarrierStatus.toLowerCase() === "cancelled" ||
                response.DeliveryStatus.toLowerCase() === "cancelled"
              ) {
                scope.showCancelPage = true;
                scope.showInvalidResponsePage,
                  scope.showDeliveredOrOnItsWay,
                  (scope.showRescheduleContainer = false);
              } else if (response.CanModify === false) {
                scope.showDeliveredOrOnItsWay = true;
                scope.showRescheduleContainer,
                  scope.showInvalidResponsePage,
                  (scope.showCancelPage = false);
              } else {
                scope.selected.PickUpStoreName = response.PickUpStoreName;
                scope.selected.orderNumber = response.OrderId;
                scope.selected.FirstName = response.FirstName;
                scope.selected.LastName = response.LastName;
                scope.selected.email = response.Email;
                scope.selected.Contact = response.Contact;
                scope.selected.preferContactMethod = "email_pcm";
                scope.selected.comment = { body: "" };

                document.querySelector(".reschedule-delivery").style.display =
                  "block";
                scope.showRescheduleContainer = true;
              }
            }
          });
      };

      scope.GetOrdersReschedule();

      scope.options = {
        deliveryDays: null,
        deliveryTimes: null,
        closedDays: null,
        noSlots: ["Time slots are not available"],
      };

      scope.selected = {
        isActive: null,
        deliveryDay: {
          value: "",
          label: "Choose delivery date",
        },
        deliveryTime: {
          value: "",
          label: "Choose delivery time",
        },
      };

      scope.formatDate = function (usrFrndlyDate) {
        const dateObj = new Date(formatDateString(usrFrndlyDate));
        var monthf = dateObj.getMonth() + 1;
        return dateObj.getFullYear() + "-" + monthf + "-" + dateObj.getDate();
      };

      missedDeliveryService.setReDeliveryCutOff(function() {
          scope.options.closedDays = missedDeliveryService.getClosedDays();
      });

      scope.options.deliveryDays = missedDeliveryService.getDeliveryDays();

      scope.changeDeliveryDay = (option) => {
        scope.selected.deliveryDay = option;
        scope.selected.deliveryTime = {
          value: "",
          label: "Choose delivery time",
        };
        scope.options.deliveryTimes = missedDeliveryService.getDeliveryTimes(
          scope.selected.deliveryDay.value
        );
      };

      scope.changeDeliveryTime = (option) => {
        scope.selected.deliveryTime = option;
      };

      scope.selectPreferredContactMethod = (preferedContactMethod) => {
        scope.selected.preferContactMethod = preferedContactMethod;
      };

      scope.checkDropDownValidity = (field) => {
        if (
          scope.selected.isActive === "reDeliver" &&
          scope.rescheduleDeliveryForm.$submitted
        ) {
          if (field === "deliveryDay") {
            return scope.selected.deliveryDay.label === "Choose delivery date";
          } else if (field === "deliveryTime") {
            return scope.selected.deliveryTime.label === "Choose delivery time";
          }
        }
      };

      scope.todayDate = function () {
        const d = new Date();
        const tdate = d.getDate();
        const tomdate = tdate + 1;
        const tmonth = d.getMonth();
        const tYear = d.getFullYear();

        const ddate = new Date(scope.reschDetails.DeliveryAtDateTime).getDate();
        const dmonth = new Date(
          scope.reschDetails.DeliveryAtDateTime
        ).getMonth();
        const dyear = new Date(
          scope.reschDetails.DeliveryAtDateTime
        ).getFullYear();

        if (tdate == ddate && tmonth == dmonth && tYear == dyear) {
          return "today";
        }
        if (tomdate == ddate && tmonth == dmonth && tYear == dyear) {
          return "tomorrow";
        }
        return "";
      };

      scope.getDate = function (dtValue) {
        var regex = /^(\d{1,2}) (am|pm) - (\d{1,2}) (am|pm)$/;
        var match = dtValue.match(regex);
        if (match) {
          var startHour = parseInt(match[1]);
          var startPeriod = match[2];
          if (startPeriod === "pm" && startHour < 12) {
            startHour += 12;
          }
          return startHour.toString().padStart(2, "0") + ":00:00";
        }
        return "";
      };

      scope.showConfirmPickup = function () {
        if ($("#pickupDeliveryForm")[0].checkValidity()) {
          rescheduleDeliveryService
            .OrdersReschedule($rootScope.orderNumber)
            .then((response) => {
              $rootScope.rescheduleResponse = response;
              if (response.CanModify === true) {
                if (!scope.pickupDeliveryForm.$valid) {
                  window.scrollTo(600, 600);
                  return;
                }
                scope.confirmPick();
              } else {
                scope.showDeliveredOrOnItsWay = true;
                scope.showRescheduleContainer,
                  scope.showInvalidResponsePage,
                  (scope.showCancelPage = false);
              }
            });
        }
      };

      scope.confirmPick = function () {
        atm.push(
          {
            linkName: `web:reschedule delivery form`,
            linkType: "pickup confirmation form",
          },
          pdpLinkClickMapper
        );

        if (window.grecaptcha && scope.showReCaptcha) {
          scope.pickupDeliveryForm.GoogleReCaptchaResponse =
            window.grecaptcha.getResponse();
        }
        if (scope.showReCaptcha) {
          googleCaptchaService
            .validategooglecaptcha(scope.pickupDeliveryForm)
            .then(function (res) {
              const { Success, FieldErrors } = res;
              if (!Success) {
                scope.rescheduleDeliveryValidationErrors = FieldErrors;
                scope.showReCaptchaErrorMessage = true;
                if (window.grecaptcha && scope.showReCaptcha) {
                  window.grecaptcha.reset();
                }
                return;
              }
              if (Success) {
                scope.showReCaptchaErrorMessage = false;
              }
              scope.submitConfirmPickupForm();
            });
        } else {
          scope.submitConfirmPickupForm();
        }
      };

      scope.submitConfirmPickupForm = function () {
        scope.loading = true;
        rescheduleDeliveryService
          .confirmPick(scope.selected)
          .then((response) => {
            if (!!response.data && response.data.error) {
              scope.errorOnSubmit();
            } else {
              $location.path("/pckcnf/" + $rootScope.orderNumber);
            }
            scope.loading = false;
            window.scrollTo(0, 0);
          }, () => {
            scope.errorOnSubmit();
            scope.loading = false;
            window.scrollTo(0, 0);
          });
      };

      scope.cancelledOrder = function () {
        if ($("#cancelDeliveryForm")[0].checkValidity()) {
          rescheduleDeliveryService
            .OrdersReschedule($rootScope.orderNumber)
            .then((response) => {
              $rootScope.rescheduleResponse = response;
              if (response.CanModify === true) {
                if (!scope.cancelDeliveryForm.$valid) {
                  window.scrollTo(600, 600);
                  return;
                }
                scope.cancelConfirmed();
              } else {
                scope.showDeliveredOrOnItsWay = true;
                scope.showRescheduleContainer,
                  scope.showInvalidResponsePage,
                  (scope.showCancelPage = false);
              }
            });
        }
      };

      scope.cancelConfirmed = function () {
        atm.push(
          {
            linkName: `web:reschedule delivery form`,
            linkType: "cancel confirmation form",
          },
          pdpLinkClickMapper
        );

        if (window.grecaptcha && scope.showReCaptcha) {
          scope.cancelDeliveryForm.GoogleReCaptchaResponse =
            window.grecaptcha.getResponse();
        }
        if (scope.showReCaptcha) {
          googleCaptchaService
            .validategooglecaptcha(scope.cancelDeliveryForm)
            .then(function (res) {
              const { Success, FieldErrors } = res;
              if (!Success) {
                scope.rescheduleDeliveryValidationErrors = FieldErrors;
                scope.showReCaptchaErrorMessage = true;
                if (window.grecaptcha && scope.showReCaptcha) {
                  window.grecaptcha.reset();
                }
                return;
              }
              if (Success) {
                scope.showReCaptchaErrorMessage = false;
              }
              scope.submitCanceledOrderForm();
            });
        } else {
          scope.submitCanceledOrderForm();
        }
      };

      scope.submitCanceledOrderForm = function () {
        scope.loading = true;
        rescheduleDeliveryService
          .cancelConfirmed(scope.selected)
          .then((response) => {
            if (!!response.data && response.data.error) {
              scope.errorOnSubmit();
            } else {
              scope.showCancelConfirmationPage = true;
              scope.showCancelPage = false;
              scope.showInvalidResponsePage = false;
              scope.showDeliveredOrOnItsWay = false;
              scope.showRescheduleContainer = false;
            }
            scope.loading = false;
            window.scrollTo(0, 0);
          }, () => {
            scope.errorOnSubmit();
            scope.loading = false;
            window.scrollTo(0, 0);
          });
      };

      scope.rescheduledDelivery = function () {
        if ($("#rescheduleDeliveryForm")[0].checkValidity()) {
          if (scope.selected.isActive === "reDeliver") {
            if (
              scope.checkDropDownValidity("deliveryDay") ||
              scope.checkDropDownValidity("deliveryTime")
            ) {
              return;
            }
            scope.options.isTimeSlotExpire =
              missedDeliveryService.isTimeSlotExpire(
                scope.selected.deliveryDay.value,
                scope.selected.deliveryTime.value
              );
          }
          scope.rescheduledConfirmed();
        }
      };

      scope.rescheduledConfirmed = function () {
        atm.push(
          {
            linkName: `web:reschedule delivery form`,
            linkType: "reschedule confirmation form",
          },
          pdpLinkClickMapper
        );

        rescheduleDeliveryService
          .OrdersReschedule($rootScope.orderNumber)
          .then((response) => {
            $rootScope.rescheduleResponse = response;
            if (response.CanModify === true) {
              if (window.grecaptcha && scope.showReCaptcha) {
                scope.rescheduleDeliveryForm.GoogleReCaptchaResponse =
                  window.grecaptcha.getResponse();
              }
              if (scope.showReCaptcha) {
                googleCaptchaService
                  .validategooglecaptcha(scope.rescheduleDeliveryForm)
                  .then(function (res) {
                    const { Success, FieldErrors } = res;
                    if (!Success) {
                      scope.rescheduleDeliveryValidationErrors = FieldErrors;
                      scope.showReCaptchaErrorMessage = true;
                      if (window.grecaptcha && scope.showReCaptcha) {
                        window.grecaptcha.reset();
                      }
                      return;
                    }
                    if (Success) {
                      scope.showReCaptchaErrorMessage = false;
                    }
                    scope.submitRescheduleDeliveryForm();
                  });
              } else {
                scope.submitRescheduleDeliveryForm();
              }
            } else {
              scope.showDeliveredOrOnItsWay = true;
              scope.showRescheduleContainer,
                scope.showInvalidResponsePage,
                (scope.showCancelPage = false);
            }
          });
      };

      scope.submitRescheduleDeliveryForm = function () {
        scope.loading = true;

        const dates = scope.getDate(scope.selected.deliveryTime.value);
        const time = scope.formatDate(scope.selected.deliveryDay.value);

        const handleYelloReschedule = () => {
          const modifyRequest = {
            OrderReference: $rootScope.rescheduleResponse.BookingReference,
            OrderID: $rootScope.OrderNo,
            WindowDates: dates + " " + time,
            WindowTime: dates + " " + time,
          };

          rescheduleDeliveryService
            .rescheduledConfirmedYello(modifyRequest)
            .then(handleRescheduleSuccess)
            .catch(handleRescheduleError);
        };

        const handleOtherCarrierReschedule = () => {
          const modifyRequest = {
            BookingReference: $rootScope.rescheduleResponse.BookingReference,
            DeliveryAtWindow: dates + " " + time,
            DeliveryAtWindowDate: dates,
            DeliveryAtWindowTime: time,
            WindowRange: {
              StartTime: null,
              EndTime: null,
              ActualTime: null,
              IsActive: true,
            },
          };

          rescheduleDeliveryService
            .rescheduledConfirmed(modifyRequest)
            .then(handleRescheduleSuccess)
            .catch(handleRescheduleError);
        };

        const handleRescheduleSuccess = (res) => {
          const day = btoa(scope.selected.deliveryDay.value);
          const time = btoa(scope.selected.deliveryTime.value);

          $location.path(`/rsccnf/${$rootScope.orderNumber}/${day}/${time}`);
        };

        const handleRescheduleError = (error) => {
          scope.showInvalidResponsePage = true;
        };

        const resetLoadingSpinner = () => {
          scope.loading = false;
        };

        if (
          $rootScope.rescheduleResponse.CarrierName.toLowerCase() === "yello"
        ) {
          handleYelloReschedule();
        } else {
          handleOtherCarrierReschedule();
        }
        resetLoadingSpinner();
      };

      scope.errorOnSubmit = () => {
        scope.showInvalidResponsePage = true;
        if (window.grecaptcha && scope.showReCaptcha) {
          window.grecaptcha.reset();
        }
      };
    },
  };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/rescheduledelivery/rescheduledelivery-directives.js
 **/